import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig'
import { InstallerListResp } from 'domain/payload/response/installer/InstallerListResp';
import { InstallerDetailResp } from 'domain/payload/response/installer/InstallerDetailResp';
import { InstallerCreateReq } from 'domain/payload/request/installer/InstallerCreateReq';
import { InstallerUpdateReq } from 'domain/payload/request/installer/InstallerUpdateReq';
import {
  UserCurrentTaskResp,
  UserHistoryTaskResp,
  UserHistoryByDateResp,
  UserViewDetailResp
} from 'domain/payload/response/user/UserViewResp';

const InstallerService = () => {
  const installerList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<InstallerListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/installer/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error;
    }
  };

  const installerDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<InstallerDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/installer/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error;
    }
  };

  const installerExportToCsv = async (token: string): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/report-engine/download?reportCode=INSTALLER_CSV_EXPORT&extension=csv`, {}, { 
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  const installerInvite = async (
    token: string,
    request: InstallerCreateReq
  ): Promise<BaseResponse<InstallerDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/installer/invite`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error;
    }
  };

  const installerUpdate = async (
    token: string,
    request: InstallerUpdateReq
  ): Promise<BaseResponse<InstallerDetailResp>> => {
    try {
      const response = await axiosInstance.put(`/v1/legacy/cms/installer/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data

    } catch (error: any) {
      throw error;
    }
  };

  const installerDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/installer/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error;
    }
  };

  const userView = async (
    token: string,
    userId: string
  ): Promise<BaseResponse<UserViewDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/installer/view`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { userId },
      });
      
      return response.data;
    } catch (error: any) {
      throw error;
    }
  };

  const userTask = async (
    token: string,
    userId: string,
    page?: number,
    size?: number,
    search?: string,
    projectId?: string | null
  ): Promise<BaseResponse<UserCurrentTaskResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/installer/tasks`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { 
          userId,
          page,
          size,
          search,
          projectId
        },
      });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  };

  const userHistory = async (
    token: string,
    userId: string,
    page?: number,
    size?: number,
    search?: string,
    projectId?: string | null
  ): Promise<BaseResponse<UserHistoryTaskResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/installer/history`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { 
          userId,
          page,
          size,
          search,
          projectId
        },
      });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  };

  const userHistoryByDate = async (
    token: string,
    userId: string,
    date: string,
    page?: number,
    size?: number,
    search?: string,
    projectId?: string | null
  ): Promise<BaseResponse<UserHistoryByDateResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/installer/history-by-date`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { 
          userId,
          date,
          page,
          size,
          search,
          projectId
        },
      });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  };

  return {
     installerList,
     installerDetail, 
     installerExportToCsv, 
     installerCreate: installerInvite, 
     installerUpdate, 
     installerDelete,
     userView,
     userTask,
     userHistory,
     userHistoryByDate,
  };
};

export default InstallerService;